<ion-item
  class="core-field-item"
  [ngClass]="{'readonly': task?.seguidor || !!field.uploadingImage}"
>

  @if (field.observaciones) {
    <ion-note slot="start">
      <yu-icon name="warning-circle" color="error"></yu-icon>
    </ion-note>
  }

  <ion-label class="ion-text-wrap">

    <p class="title">
      {{ field.label }}

      @if (field.imagen) {
        <yu-icon name="image" color="info" (click)="openImage.emit()"></yu-icon>
      }
    </p>

    <p
      class="info"
      [ngClass]="{'ion-text-wrap': field.info_open}"
      [innerHTML]="field.info"
    ></p>

    @if (field.incidencia_anterior) {
      <div class="info previous-incidence">
        <yu-icon name="warning-circle" color="warning"></yu-icon>
        <p [innerHTML]="field.incidencia_anterior"></p>
      </div>
    }

    @if (field.observaciones && menu === 'incidents') {
      <p class="info incidence">{{ field.observaciones }}</p>
    }

    <ng-content select="[field-label]"></ng-content>

    @if ((field.value || field.no_necesario) && field.usuario) {
      <p class="author">{{ field.updated }} · {{ field.usuario }}</p>
    }

  </ion-label>

  <ion-note slot="end">

    @if (field.uploadingImage) {

      <ion-spinner name="circular"></ion-spinner>

    } @else if (field.no_necesario) {

      <p class="not-necessary">{{ 'ITEMS.TASKS.NOT_NECESSARY' | translate }}</p>

    } @else {

      @if (field.foto) {
        <div
          class="camera-icon-wrapper"
          [ngClass]="{'upload-image': field.foto_subida, 'obligatory-image': field.foto_obligada && !field.foto_subida}"
          (click)="takeImage.emit()"
        >
          <yu-icon
            name="camera"
            [color]="field.foto_subida ? 'success' : (field.foto_obligada ? 'error' : 'medium')"
          ></yu-icon>
        </div>
      }

      <ng-content select="[field-note]"></ng-content>

    }

  </ion-note>

</ion-item>
